export default __webpack_public_path__ + "static/media/TRUCK1.f7709e93.jpg";